module.exports = __webpack_public_path__ + "img/icon_home.0c2c1b22.svg";